export const layerToVariable = {
    'Air temperature': 'air.temperature.at-2m',
    Gusts: 'wind.speed.gust.at-10m',
    Pressure: 'air.pressure.at-sea-level',
    Precipitation: 'precipitation.rate',
    Visibility: 'air.visibility',
    Wind: 'wind.speed.eastward.at-10m',
    Current: 'current.speed.eastward.at-sea-surface',
    'Wave peak period': 'wave.period.peak',
    'Sea temperature': 'sea.temperature.at-surface',
    'Wave height': 'wave.height',
    'Rain radar': 'reflectivity',
    Satellite: 'ir',
    'Wind sea height': 'wave.height.below-8s',
    'Swell height': 'wave.height.above-8s',
    'Swell peak period': 'wave.period.above-8s.peak',
    'Wind sea peak period': 'wave.period.below-8s.peak',
    'Total sea surface height': 'sea.surface.height.above-geoid',
    'Lightning Prediction': 'lightning.threat',
};

export const variableToLayer = {
    'air.temperature.at-2m': 'Air temperature',
    'wind.speed.gust.at-10m': 'Gusts',
    'air.pressure.at-sea-level': 'Pressure',
    'precipitation.rate': 'Precipitation',
    'air.visibility': 'Visibility',
    'wind.speed.eastward.at-10m': 'Wind',
    'current.speed.eastward.at-sea-surface': 'Current',
    'wave.period.peak': 'Wave peak period',
    'sea.temperature.at-surface': 'Sea temperature',
    'wave.height': 'Wave height',
    reflectivity: 'Rain radar',
    ir: 'Satellite',
    'wave.height.below-8s': 'Wind sea height',
    'wave.height.above-8s': 'Swell height',
    'wave.period.above-8s.peak': 'Swell peak period',
    'wave.period.below-8s.peak': 'Wind sea peak period',
    'sea.surface.height.above-geoid': 'Total sea surface height',
    'lightning.threat': 'Lightning Prediction',
};

export type WxVariables = keyof typeof variableToLayer;

export const getLayerFromVariable = (variable: WxVariables | WxVariables[]) => {
    if (Array.isArray(variable)) {
        return variableToLayer[variable[0]];
    }
    return variableToLayer[variable];
};
